import { colors } from 'muiTheme/palette';

export const ACTION_CELL_KEYS = {
  ACTION_TEXT: 'action_text',
  DESIRED_OUTCOME: 'desired_outcome',
  STATUS: 'status',
  DEADLINE: 'deadline',
  OWNER: 'owner',
  OWNER_DETAILS: 'owner_details',
  SUPPORT_NEEDED: 'support_needed',
};

export const ACTION_FIELD_LABELS = {
  [ACTION_CELL_KEYS.ACTION_TEXT]: 'Action',
  [ACTION_CELL_KEYS.DESIRED_OUTCOME]: 'Desired Outcome',
  [ACTION_CELL_KEYS.STATUS]: 'Status',
  [ACTION_CELL_KEYS.DEADLINE]: 'Deadline',
  [ACTION_CELL_KEYS.OWNER]: 'Owner',
  [ACTION_CELL_KEYS.OWNER_DETAILS]: 'Owner',
  [ACTION_CELL_KEYS.SUPPORT_NEEDED]: 'Support Needed',
};

export const ACTION_STATUSES = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  STUCK: 'stuck',
  COMPLETED: 'completed',
};

export const ORDERED_ACTIONS_STATUSES = [
  ACTION_STATUSES.NOT_STARTED,
  ACTION_STATUSES.IN_PROGRESS,
  ACTION_STATUSES.STUCK,
  ACTION_STATUSES.COMPLETED,
];

export const ACTION_STATUS_LABELS = {
  [ACTION_STATUSES.NOT_STARTED]: 'Not Started',
  [ACTION_STATUSES.IN_PROGRESS]: 'In Progress',
  [ACTION_STATUSES.STUCK]: 'Stuck',
  [ACTION_STATUSES.COMPLETED]: 'Completed',
};

export const ACTION_STATUS_COLORS = {
  [ACTION_STATUSES.NOT_STARTED]: 'default',
  [ACTION_STATUSES.IN_PROGRESS]: 'info',
  [ACTION_STATUSES.STUCK]: 'warning',
  [ACTION_STATUSES.COMPLETED]: 'success',
};

export const ACTION_CHIP_BACKGROUND_COLORS = {
  default: colors.liteLilac,
  info: colors.statusBlue,
  warning: colors.statusYellow,
  success: colors.statusGreen,
  error: colors.statusRed,
};

export const ACTION_TRACKER_CELL_KEYS = {
  PROJECT: 'project_name',
  SEGMENT: 'segment_display',
  ACTION: 'action_text',
  DESIRED_OUTCOME: 'desired_outcome',
  STATUS: 'status',
  DEADLINE: 'deadline',
  OWNER: 'owner_details',
  PROJECT_STATUS: 'project_status',
  OPTIONS: 'options',
};

export const ALL_SEGMENTS_NAME = 'All segments';

export const ACTION_TRACKER_TABS = {
  ALL: 'all_actions',
  PERSONAL: 'personal_actions',
};

export const ADD_ROW_ID = 'add-row';

export const PENDING_ROW_ID = 'pending-row';
